import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputBase from "@mui/material/InputBase";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import React from "react";
import { useGeotabClient } from "../GeotabClientContext";

const SessionSwitcher = ({ isMobile }: { isMobile?: boolean }) => {
  const { activeSessionId, switchSession, clearGeotabClient, sessions } = useGeotabClient();

  // Handle session selection
  const handleSessionChange = (event: SelectChangeEvent) => {
    const sessionId = event.target.value as string;
    if (sessionId) {
      switchSession(sessionId);
    }
  };

  // Handle session deletion
  const handleSessionDelete = () => {
    if (activeSessionId) {
      clearGeotabClient(activeSessionId);
    }
  };

  return (
    // <Box display="flex" alignItems="center" justifyContent="space-between" sx={{}}>
    <>
      <FormControl variant="standard" fullWidth>
        <Select
          labelId="sessionSwitcher-label"
          value={activeSessionId || ""}
          onChange={handleSessionChange}
          label="Select Session"
          sx={{
            color: "white",
          }}
          input={<InputBase />}
        >
          {sessions.map((sessionId: string) => (
            <MenuItem key={sessionId} value={sessionId}>
              {sessionId}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        variant="contained"
        onClick={handleSessionDelete}
        disabled={!activeSessionId}
        sx={isMobile ? {} : { mx: 2 }}
        fullWidth={isMobile}
      >
        <DeleteIcon />
      </Button>
    </>
    // </Box>
  );
};

export default SessionSwitcher;
